const three={
	title: '`housing` - це гарантiя',
	img:[
		'bi/avgust_26_2016_stranica_2_willow.png',
		'bi/dsfdsfdsf.png',
		'bi/6d464069f3ce6c83d4e51a33736817f0.jpg',
		'bi/depositphotos_47009329-stock-photo-glazed-and-unglazed-ceramic-flower.png',
	],
	text: 'Продукція нашої Компанії виготовляється з якісних та екологічно\
		безпечних матеріалів. Також ми завжди готові піти Вам назустріч та,\
		при необхідності, зробити заміну товару, який, з тої чи\
		іншої причини, Вам не підійшов. '
};

export default three;